export const mouths = {
  long: {
    smile: {
      d: "M 1238 1535 a 78 258 189 0 0 35 0",
      className: "prev--mouth outline",
    },
    straight: {
      className: "prev--mouth main",
      d: "M1275 1535C1268.15 1530.48 1259.6 1531.39 1252 1533.49C1249.36 1534.22 1244.12 1535.96 1245.09 1539.73C1245.85 1542.69 1250.68 1542.02 1252.91 1541.91C1260.82 1541.49 1268.19 1538.96 1275 1535z",
    },
    tongue: {
      className: "prev--mouth tongue",
      outline:
        "M1298 1553C1288.63 1553.41 1279.99 1557.9 1271 1560.27C1267.7 1561.13 1262.46 1561.09 1260.5 1564.31C1256.57 1570.78 1255.15 1583.91 1257.89 1591C1261.33 1599.87 1272.07 1599.32 1277.61 1592.9C1284.64 1584.73 1281.82 1573.12 1286.51 1564.22C1289.38 1558.79 1296.81 1560.03 1298 1553z",
      fill: "M1281 1563L1273 1565C1272.74 1570.88 1271.71 1576.17 1267 1580L1267 1566C1260.72 1568.21 1258.87 1588.52 1265.23 1591.73C1275.42 1596.87 1282.31 1569.24 1281 1563z",
    },
  },
  button: {
    smile: {
      d: "M 1265 1545 a 78 258 189 0 0 35 0",
      className: "prev--mouth outline",
    },
    straight: {
      d: "M 1285 1550 l 20 0",
      className: "prev--mouth outline",
    },
    tongue: {
      className: "prev--mouth tongue",
      outline:
        "M1252 1543C1253.55 1552.93 1264.06 1552.56 1272 1552C1272.52 1563.97 1285.2 1587.8 1298.58 1571.89C1303.77 1565.72 1303 1556.5 1303 1549C1312.12 1548.99 1321.82 1546.59 1323 1536L1303 1542.23L1284.04 1531.55L1271 1542.86L1252 1543z M1253 1544C1256.82 1551.74 1265.55 1551.38 1273 1550C1273.46 1560.61 1284.35 1586.53 1297.58 1570.89C1302.67 1564.87 1302 1555.35 1302 1548C1310.61 1547.98 1318.93 1546 1322 1537C1315.01 1538.81 1309.88 1545.22 1302 1543.61C1295.77 1542.32 1289.96 1532.48 1284.1 1533.18C1279.59 1533.72 1275.96 1541.78 1272 1544.14C1265.89 1547.78 1259.4 1544.56 1253 1544z",
      fill: "M1286 1540L1288 1559C1283.5 1554.72 1283.05 1547.97 1283 1542C1264.88 1554.92 1293.46 1585.29 1298.38 1558C1299.04 1554.35 1299 1550.7 1299 1547L1286 1540z",
    },
    chibi: {
      className: "prev--mouth main",
      d: "M1282 1531C1278.83 1536.56 1274 1543.86 1267 1544.65C1261.78 1545.23 1257.27 1542.55 1252 1544C1257.9 1558.79 1278.75 1551.25 1284 1540C1293.28 1544.71 1300.63 1551.9 1312 1548.04C1314.85 1547.08 1324.68 1542.08 1321.83 1537.66C1319.91 1534.67 1314.49 1539.47 1312.71 1540.51C1299.54 1548.21 1293.34 1533.44 1282 1531z",
    },
  },
  heart: {
    smile: {
      className: "prev--mouth main",
      d: "M1323 1510C1316.75 1519.53 1312.57 1514.33 1304 1512C1305.91 1526.32 1326.06 1525.01 1327 1511L1323 1510z",
    },
    straight: {
      className: "prev--mouth main",
      d: "M1326 1509C1323.69 1508.21 1321.45 1507.46 1319 1507.26C1317.33 1507.12 1315.66 1507.19 1314 1507.45C1299.97 1509.72 1322.01 1522.24 1326 1509z",
    },
    tongue: {
      className: "prev--mouth tongue",
      outline:
        "M1303 1520C1306.18 1541.18 1330.54 1541.21 1331 1519C1336.88 1520.4 1344.03 1520.1 1348.66 1515.61C1350.64 1513.68 1353.27 1509.1 1350.39 1506.74C1347.2 1504.12 1340.1 1511.96 1336 1512.09C1330.67 1512.27 1324.99 1509.29 1321.99 1504.91C1320.19 1502.27 1319.13 1496.64 1315.06 1496.64C1310.6 1496.64 1306.77 1508.49 1302 1510.82C1294.9 1514.28 1290.31 1504.38 1284.32 1506.66C1279.89 1508.35 1284.09 1513.92 1286.06 1515.66C1291.03 1520.05 1296.76 1520 1303 1520z",
      fill: "M1312 1513L1307 1517C1308.97 1521.72 1311.97 1529.77 1317.99 1530.34C1329.31 1531.41 1323.89 1516.19 1318 1513L1319 1525L1312 1513z",
    },
    chibi: {
      className: "prev--mouth main",
      d: "M1282 1507L1282 1512C1292.58 1519.98 1307.14 1524.69 1315 1510C1321.7 1517.11 1331.16 1521.19 1341 1518.98C1344.97 1518.09 1353.94 1513.79 1351.16 1508.15C1349.44 1504.67 1336.84 1512.83 1332 1511.66C1328.02 1510.7 1324.09 1508.34 1321.72 1504.96C1320.07 1502.58 1319.29 1497.63 1315.86 1497.06C1311.03 1496.26 1306.66 1509.66 1300.99 1511.33C1293.69 1513.48 1289.15 1505.77 1282 1507z",
    },
    puppycat: {
      className: "prev--mouth main",
      d: "M1315 1504C1324.42 1509.45 1332.97 1528.5 1345 1526C1343.83 1519.7 1339.93 1516.48 1335.75 1511.93C1330.97 1506.71 1323.86 1496.21 1316 1496.22C1309.69 1496.22 1290.97 1513.94 1293.66 1520.68C1294.95 1523.92 1299.03 1522.02 1300.91 1520.57C1306.25 1516.44 1311.94 1509.99 1315 1504z",
    },
  },
};
export const noses = {
  heart: {
    path: "M1320 1496C1323.06 1495.57 1326.18 1495 1329.17 1494.16C1335.35 1492.42 1344.16 1482.05 1334.15 1478.68C1328.06 1476.64 1322.7 1481.89 1317 1482.76C1311.48 1483.6 1291.2 1474.05 1294.33 1488C1296 1495.42 1302.93 1492.89 1307.57 1496.03C1310.17 1497.79 1310.39 1501.49 1313.14 1503.2C1318.34 1506.43 1320.49 1499.89 1320 1496z",
    options: mouths.heart,
  },

  button: {
    path: "M1279 1500.61C1273.29 1500.96 1258.99 1505.44 1265.01 1513.61C1267.81 1517.4 1273.19 1516.91 1276.15 1520.31C1279.36 1524.01 1278.68 1536.09 1284.99 1535.99C1292.69 1535.87 1285.92 1523.5 1288.89 1519.89C1292.44 1515.59 1300.52 1517.84 1304.39 1512.67C1313.07 1501.1 1284.37 1500.28 1279 1500.61z",
    options: mouths.button,
  },

  long: {
    path: "M1179 1513C1180.31 1520.68 1191.88 1527.35 1198.05 1531.71C1217.44 1545.41 1243.39 1565.93 1268 1566L1268 1565C1245.89 1555.75 1223.86 1538.75 1204.6 1524.5C1197.85 1519.51 1192.55 1511.52 1185 1508C1188.8 1501.42 1195.29 1495.13 1194 1487L1232 1476.21L1262 1468C1255.55 1462.85 1247.51 1464.95 1240 1466.25C1222.59 1469.27 1206.83 1475.82 1190 1480.51C1182.16 1482.69 1174.53 1480.2 1167.17 1485.21C1151.06 1496.19 1168.39 1508.76 1179 1513z",
    options: mouths.long,
  },
};
export const eyes = {
  squinty: {
    base: {
      className: "prev--eyes base",
      d: "M1103 1394C1109.85 1400.99 1125.43 1395.49 1131 1389C1121.38 1386.16 1111.58 1389.62 1103 1394z",
    },
    main: {
      className: "prev--eyes main",
      d: "M 1120 1393 a 4,4 0 1,1 0,-1 z",
    },
    outline: {
      className: "prev--eyes outline",
      d: "M1120 1380.43C1113.02 1381.43 1104.4 1382.78 1099.43 1388.33C1088.92 1400.07 1105.89 1404.9 1115 1403.71C1123.04 1402.66 1134.62 1399.48 1138.98 1391.98C1145.28 1381.15 1126.41 1379.51 1120 1380.43z",
    },

    rBase: {
      className: "prev--eyes base",
      d: "M1558 1375C1564.85 1381.99 1580.43 1376.49 1586 1370C1576.38 1367.16 1566.58 1370.62 1558 1375z",
    },
    rMain: {
      className: "prev--eyes main",
      d: "M 1575 1375 a 4,4 0 1,1 0,-1 z",
    },
    rOutline: {
      className: "prev--eyes outline",
      d: "M1575 1361.43C1568.02 1362.43 1559.4 1363.78 1554.43 1369.33C1543.92 1381.07 1560.89 1385.9 1570 1384.71C1578.04 1383.66 1589.62 1380.48 1593.98 1372.98C1600.28 1362.15 1581.41 1360.51 1575 1361.43z",
    },
  },
  closed: {
    outline: {
      className: "prev--eyes closed",
      d: "M1118.41 1471.26C1114.02 1472.87 1117.68 1478.23 1118.94 1480C1123.65 1486.63 1130.03 1491.96 1137 1496.07C1155.71 1507.11 1180.75 1507.35 1199 1495.18C1203.72 1492.03 1208.48 1488.08 1211.19 1483C1212.42 1480.69 1213.36 1475.5 1209.03 1476.05C1203.67 1476.72 1198.32 1485.04 1194 1488.01C1184.65 1494.45 1172.19 1497.31 1161 1495.56C1148.7 1493.64 1138.07 1487.3 1129 1478.91C1126.67 1476.75 1121.28 1469.41 1117.41 1471.26z",
    },
    rOutline: {
      className: "prev--eyes closed",
      d: "M1574.08 1455.18C1567.72 1457.72 1561.28 1471.91 1556 1476.96C1539.44 1492.81 1514.89 1502.1 1492 1498.08C1482.6 1496.43 1474.49 1492.61 1466 1488.48C1464.26 1487.63 1458.76 1484.1 1457.18 1486.66C1453.34 1492.86 1473.4 1500.79 1477 1502.19C1497.86 1510.26 1523.34 1508.02 1543 1497.51C1555.28 1490.95 1565.84 1481.48 1573.57 1469.91C1574.88 1467.96 1583.08 1451.58 1574.08 1455.18z",
    },
  },
  round: {
    main: {
      className: "prev--eyes main",
      d: "M1147.05 1436.74C1136.49 1441.1 1143.54 1459.63 1154.98 1454.99C1166.96 1450.14 1159.54 1431.59 1147.05 1436.74z",
    },
    rMain: {
      className: "prev--eyes main",
      d: "M1489.01 1432.5C1474.86 1435.29 1481.43 1457.08 1495 1453.97C1508.79 1450.8 1502.64 1429.81 1489.01 1432.5z",
    },
    outline: {
      className: "prev--eyes outline",
      d: "M1148 1430.53C1126.91 1435.62 1135.47 1466.45 1156 1461.47C1176.12 1456.59 1168.03 1425.7 1148 1430.53z",
    },
    rOutline: {
      className: "prev--eyes outline",
      d: "M1492 1426.71C1470.07 1427.19 1470.02 1460.92 1492 1460.92C1514.75 1460.92 1514.99 1426.22 1492 1426.71z",
    },
  },
};
